

import { AHOC_INCIDENT_DETAILS_SET_VALUE } from "../../../actions/allsureHomeClaim/incidentDetails";
import { AHOC_BASIC_DETAILS_SET_VALUE } from "../../../actions/allsureHomeClaim/basicDetails";
import { AHOC_UPLOAD_DOCUMENTS_SET_VALUE } from "../../../actions/allsureHomeClaim/uploadDocuments";
import { incidentDetailsValidations } from "./incidentDetails";
import { basicDetailsValidation } from "./basicDetails";
import { uploadDocumentsValidation } from "./uploadDocuments";

export const allsureHomeClaimValidation = (store, next, action) => {

  if(action.type.startsWith(AHOC_BASIC_DETAILS_SET_VALUE)){
    return basicDetailsValidation(store, next, action)
  }
  if(action.type.startsWith(AHOC_INCIDENT_DETAILS_SET_VALUE)){
    return incidentDetailsValidations(store, next, action)
  }
  if(action.type.startsWith(AHOC_UPLOAD_DOCUMENTS_SET_VALUE)){
    return uploadDocumentsValidation(store, next, action)
  }
  return null;
};
